import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
} from 'react';
import styled from 'styled-components';
import InView from 'react-intersection-observer';

import { ViewContext } from '@helpers/contexts';
import { map, constrain } from '@helpers/mathUtils';

import BottleSrc from '@images/products/hardwater/bottle.png';
import LabelSrc from '@images/products/hardwater/label.png';
import OverlaySrc from '@images/products/hardwater/overlay.png';

export default ({ disabled, minTrans = 0, maxTrans = 32 }) => {
  const { scroll, mobileView, windowHeight } = useContext(ViewContext);
  const [inView, setInView] = useState(false);
  const [elemOffsetTop, setElemOffsetTop] = useState(-1);
  const labelEl = useRef();

  useLayoutEffect(() => {
    if (inView && !mobileView && !disabled) {
      setElemOffsetTop(scroll);
    }
  }, [inView, mobileView, disabled]);

  useEffect(() => {
    if (inView && !disabled && !mobileView) {
      const move = constrain(
        map(scroll - elemOffsetTop, 0, windowHeight, minTrans, maxTrans),
        minTrans,
        maxTrans
      );

      labelEl.current.style.backgroundPositionX = -move + 'px';
    }
  }, [scroll]);

  return (
    <Container onChange={inView => setInView(inView)}>
      <Overlay />
      <Label ref={labelEl} startPos={minTrans} />
      <img src={BottleSrc} alt="" />
    </Container>
  );
};

const Container = styled(InView)`
  display: block;
  position: relative;
  width: fit-content;
`;

const STYLES = `
  width: 100%;
  height: 339px;
  position: absolute;
  top: 7px;
`;

const Overlay = styled.div`
  ${STYLES};
  background-image: url(${OverlaySrc});
  mix-blend-mode: exclusion;
  z-index: 2;
`;

const Label = styled.div`
  ${STYLES};
  background-image: url(${LabelSrc});
  background-position-x: ${props => props.startPos};
`;
